// extracted by mini-css-extract-plugin
module.exports = {"stars-wrapper":"stars_stars-wrapper__zg7gU","star":"stars_star__2uVtU","star-vacant":"stars_star-vacant__Tfvup","star-intersected":"stars_star-intersected__3eeMu"};